/**
 * Onboarding Tips Component
 * Shows helpful tips for new users in the Creator Studio
 */
import React from 'react';
import { HelpCircle, ArrowRight, X } from 'lucide-react';

export function OnboardingTips({ 
  show, 
  onDismiss,
  workspaceEmpty,
  isWorkspaceView
}) {
  if (!show || !workspaceEmpty || !isWorkspaceView) return null;

  return (
    <div className="mb-6 p-4 bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/20 rounded-xl">
      <div className="flex items-start gap-3">
        <HelpCircle className="text-blue-400 shrink-0 mt-0.5" size={20} />
        <div className="flex-1">
          <h4 className="font-medium text-blue-400 mb-1">Welcome to Creator Studio!</h4>
          <p className="text-sm text-[var(--text-secondary)]">
            <strong>Step 1:</strong> Upload your comic panels (drag & drop or click) <ArrowRight className="inline" size={14} /> 
            <strong>Step 2:</strong> Apply AI tools to enhance <ArrowRight className="inline" size={14} /> 
            <strong>Step 3:</strong> Organize into episodes <ArrowRight className="inline" size={14} /> 
            <strong>Step 4:</strong> Preview & Publish!
          </p>
        </div>
        <button 
          onClick={onDismiss} 
          className="text-[var(--text-secondary)] hover:text-white"
          data-testid="dismiss-tips-btn"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}

export default OnboardingTips;
